import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from "../context/AuthContext";
import { useConfig } from '../context/ConfigContext';
import '../App.css';

const MorphUpload = (fetchData) => {
    const { user, id } = useAuth();
    const { backendApiBaseUrl } = useConfig();
    const fileInputRefs = useRef([]);
    const [images, setImages] = useState([
        { file: null, label: "1" },
        { file: null, label: "2" },
    ]);
    const [duplicateMessage, setDuplicateMessage] = useState("");
    

    const [textValue, setTextValue] = useState('');
    const maxChars = 200;
    const isOverLimit = textValue.length > maxChars;

    const colorOptions = [
        "black", "white", "red", "purple", "blue", "green",
        "brown", "pink", "orange", "yellow", "gray"
    ];
    const [uploadError, setUploadError] = useState("");

      

    const handleTextChange = (e) => {
        const input = e.target.value;
        setTextValue(input.slice(0, maxChars));
      };

    const [selectedColors, setSelectedColors] = useState([]);
    const [cardCode, setCardCode] = useState("");

    useEffect(() => {
        fileInputRefs.current = fileInputRefs.current.slice(0, images.length);
    }, [images]);
 

    const handleFileChange = (e, index) => {
        const file = e.target.files[0];
        if (!file) return;
    
        // Check for duplicate filenames
        const isDuplicate = images.some(
            (img, i) => img.file?.name === file.name && i !== index
        );
        if (isDuplicate) {
            setDuplicateMessage("Duplicate file names are not allowed.");
            return;
        }
        if (file.type !== "image/png") {
            setDuplicateMessage("Only PNG files are allowed.");
            return;
        }
    
        setDuplicateMessage("");
        const updated = [...images];
        updated[index].file = file;
        setImages(updated);
    };
    

    const handleAddImage = () => {
        if (images.length < 10) {
            setImages(prev => {
            const newImages = [...prev, { file: null, label: "" }];
            return newImages.map((img, idx) => ({ ...img, label: `${idx + 1}` }));
            });
        }
    };

    const handleRemoveImage = (indexToRemove) => {
        const filtered = images.filter((_, i) => i !== indexToRemove);
        const relabeled = filtered.map((img, idx) => ({ ...img, label: `${idx + 1}` }));
        setImages(relabeled);
        setDuplicateMessage("");
    };

    const handleColorChange = (e) => {
        const { value, checked } = e.target;
        if (checked) {
          setSelectedColors([...selectedColors, value]);
        } else {
          setSelectedColors(selectedColors.filter(color => color !== value));
        }
    };

    const resetForm = () => {
        setImages([
            { file: null, label: "" },
            { file: null, label: "" }
        ]);
        setTextValue("");
        setDuplicateMessage("");
        setCardCode("");
        setSelectedColors([]); 
    };


    const uploadImage = async (e) => {
        try {
            e.preventDefault();
            setUploadError("");

            const uploadFile = images[0]?.file;
            if (!uploadFile) {
                console.log("No file obtained");
                return;
            }

            const formData = new FormData();

            images.forEach((img, index) => {
                if (img.file && img.label) {
                    formData.append(`images[]`, img.file);
                    formData.append(`labels[]`, img.label);
                }
            });

            formData.append("user", JSON.stringify(user));
            formData.append("userId", JSON.stringify(id));
            formData.append("cardCode", document.getElementById("cardCode").value);
            formData.append("morphDescription", document.getElementById("morphDescription").value);
            const morphColors = [...document.querySelectorAll('input[name="morphColor[]"]:checked')].map(cb => cb.value);
            formData.append("morphColor", JSON.stringify(morphColors));
            const storedToken = localStorage.getItem('token');
            const token = JSON.parse(storedToken)?.token;
            const response = await fetch(`${backendApiBaseUrl}/morphs/upload`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                body: formData
            });

            const result = await response.json();

            if (!response.ok) {
                setUploadError(result.error || "Upload failed");
                return;
            }

            resetForm();
            fetchData.fetchData();

        } catch (error) {
            console.error("Upload error:", error);
            setUploadError("An unexpected error occurred.");
        }
    };

    const isFormValid = () => {
        const hasImages = images.some(img => img.file !== null);
        const hasCardCode = cardCode.trim().length > 0;
        const hasColors = selectedColors.length > 0;
        return hasImages && hasCardCode && hasColors && !isOverLimit;
    };



    return (
        <div style={{ padding: "10px 5px" }}>
            <form>
                <div>
                    {duplicateMessage && (
                    <div style={{ color: "red", marginBottom: "10px" }}>
                        {duplicateMessage}
                    </div>
                    )}

                    {uploadError && (
                        <div style={{ color: "red", marginBottom: "10px" }}>
                            {uploadError}
                        </div>
                    )}

                    {images.map((img, index) => (
                    <div 
                        key ={index}
                        style={{
                            background: "#313338",
                            padding: "10px",
                            borderRadius: "5px",
                            marginBottom: "20px",
                        }}
                    >
                        <div style={{ marginBottom: "10px" }}>
                            <div>
                                Image #{img.label} 
                            </div>
                            <div>
                                {index === 0 && <span style={{ fontSize: "0.8em", color: "#AAA" }}> Morph as it is now</span>}
                            </div>
                        </div>
                        

                            <input
                                type="file"
                                accept=".png"
                                onChange={(e) => handleFileChange(e, index)}
                                className="form-control"
                                ref={fileInputRefs.current[index]}
                            />

                            <div style={{ paddingTop:"5px", display :"flex", alignItems: "center", justifyContent:"Center", gap: "10px", marginBottom: "10px"}}>
                                {index > 1 && (
                                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => handleRemoveImage(index)}>
                                        -
                                    </button>
                                )}
                            </div>
                    </div>
                    ))}

                    {images.length <= 9 && (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={handleAddImage}
                        >
                            +
                        </button>
                    )}
                    </div>
                
                <div style={{marginBottom: "30px", marginTop: "30px"}}>
                    <label style={{paddingBottom:"15px", }}>*Card Code</label>
                    <input
                    className="form-control"
                    type="text"
                    id="cardCode"
                    name="cardCode"
                    maxLength={7}
                    value={cardCode}
                    onChange={(e) => setCardCode(e.target.value)}
                >
                </input>
                </div>

                <div  style={{marginBottom: "30px"}}>
                    <label style={{paddingBottom:"15px", }}>Description</label>
                    <textarea 
                        className="form-control"
                        type="text" 
                        id="morphDescription" 
                        name="morphDescription"
                        maxLength={maxChars}
                        placeholder="How much did it cost... What is it good on...."
                        value={textValue} 
                        onChange={handleTextChange}
                    >
                    </textarea>
                    <div style={{textAlign:"right", color:"#FFF",fontSize:"0.8em"}}>
                        {textValue.length}/{maxChars}
                    </div>
                </div>

                <fieldset className="mb-3">
                    <legend className="col-form-label " style={{ paddingBottom: "15px" }}>*Morph Color</legend>
                    <div className="row form-group">
                        {colorOptions.map((color) => (
                        <div className="col-6" key={color}>
                            <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                name="morphColor[]"
                                value={color}
                                checked={selectedColors.includes(color)}
                                onChange={handleColorChange}
                            />
                            <label className="form-check-label" htmlFor={`${color}Morph`}>
                                {color}
                            </label>
                            </div>
                        </div>
                        ))}
                    </div>
                </fieldset>


                <button type="submit" className="btn btn-primary mt-2" onClick={uploadImage} disabled={!isFormValid()}>
                    Upload
                </button>
                <div style={{textAlign:"center", color:"#FFF",fontSize:"0.8em"}}>
                    * Inputs are required
                </div>
                
            </form>
        </div>
        
    )
}

export default MorphUpload;